<template>
  <v-navigation-drawer
    class="menu-side-nav-padding-top"
    color="#f6f5f4"
    style="z-index: 0"
    width="256"
    fixed
    floating
    permanent
  >
    <scrollactive
      @itemchanged="onItemChanged"
      active-class="active-side-nav"
      :highlightFirstItem="true"
      :modifyUrl="false"
      :offset="offset"
    >
      <div
        v-if="menuItems"
        class="color-black-magic d-flex flex-column menu-side-nav-padding"
      >
        <v-btn
          class="mb-1 scrollactive-item d-flex justify-start"
          v-for="(items, section) in menuItems"
          :key="section.replace(/^\d/, 'abc$&')"
          :to="{
            name: 'menu',
            hash: `#${slug(section.replace(/^\d/, 'abc$&'))}`,
          }"
          min-height="40"
          rounded
          text
        >
          <span
            style="max-width: 208px"
            class="d-inline-block font-size-md no-uppercase text-truncate"
            >{{ section }}
          </span>
        </v-btn>
      </div>
    </scrollactive>
  </v-navigation-drawer>
</template>

<script>
import { slug } from "github-slugger";
import { mapGetters } from "vuex";

export default {
  name: "MenuSideNav",
  computed: {
    ...mapGetters("menu", { menuItems: "bySection" }),
  },
  created() {
    window.addEventListener("scroll", this.setOffset);
  },
  data() {
    return {
      offset: -20,
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.setOffset);
  },
  methods: {
    onItemChanged() {
      window.scrollBy(0, 5);
    },
    setOffset() {
      this.offset = 158;
    },
    slug,
  },
};
</script>

<style scoped>
.active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0;
}

.active-side-nav {
  background-color: var(--v-primary-base);
  color: var(--color-white) !important;
}

.menu-side-nav-padding {
  padding-right: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
}

.menu-side-nav-padding-top {
  padding-top: 249px;
}
</style>
